import React, { memo } from "react";
import styled from "styled-components";

const TextP = styled.p`
  color: #0946b8;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  &:hover {
    color: #072a80;
  }
`;

function TextLinkV2(props) {
  return <TextP>{props.texto}</TextP>;
}

export default memo(TextLinkV2);
